export default "<div class=\"content\">\r\n      <router-outlet></router-outlet>\r\n</div>\r\n"